import script from "./VideoDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./VideoDisplay.vue?vue&type=style&index=0&id=ded63ebe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded63ebe"]])

export default __exports__